export default __webpack_public_path__ + "static/media/circle.50963870.svg";